import React, { Component } from "react";
import Card from "../../shared/state-components/Card";
import { formatDate } from "../../shared/functions/Functions";
import { formatTransporterStatus } from "../../shared/functions/Functions";

class Profile extends Component {
  renderTransporterDetails = () => {
    return this.props.details.map(detail => (
      <div key={detail.REGN_ID}>
        <div>
          Registration Number:{" "}
          <span style={{ float: "right" }}>{detail.REGN_ID}</span>
        </div>
        <div>
          Registration Date:{" "}
          <span style={{ float: "right" }}>{formatDate(detail.REGN_DATE)}</span>
        </div>
        <div>
          Expiration Date:{" "}
          <span style={{ float: "right" }}>{formatDate(detail.EXP_DATE)}</span>
        </div>
        <div>
          Registration Status:{" "}
          <span style={{ float: "right" ,
            color: formatTransporterStatus(detail.STATUS_IND).toLowerCase() === "suspended"
                              ? "red" : "",
          }}>
            {formatTransporterStatus(detail.STATUS_IND)}
          </span>
        </div>
        <div>
          County: <span style={{ float: "right" }}>{detail.TRANS_CNTY}</span>
        </div>
        {detail.LAST_ACT_DATE != null &&       
        <div>
          Last Updated:{" "}
          <span style={{ float: "right" }}>
            {detail.LAST_ACT_DATE}
          </span>
        </div>       
        }
        <div>
          Record Entered:{" "}
          <span style={{ float: "right" }}>
            {formatDate(detail.CREATE_DATE)}
          </span>
        </div>
        <div>
          Legal Entity:{" "}
          <span style={{ float: "right" }}>
            {detail.PARENT_CMPY}
          </span>
        </div>
      </div>
    ));
  };

  render() {
    return (
      <div>
        <Card
          cardType="default"
          cardHeader="Transporter Details"
          headerColor="#046B99"
          headerTextColor="white"
          cardBody=""
          cardColor="white"
        >
          <div className="facility-address-card">
            {this.renderTransporterDetails()}
          </div>
        </Card>
      </div>
    );
  }
}

export default Profile;
